import React from 'react';
import Layout from '../layout/layout';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import './faq.css';

const FaqPage = () => {
  return (
    <Layout>
      <div className='faq-page'>
        <div className='container'>
         <div className='faq-section'>
         <div className='affiliate-heading'>
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className='faq-accordion'>
            <Accordion>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is RubyRoll?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Rollbit is Crypto's Most Rewarding Casino. Rollbit was
                    founded in February 2020 by a team of entrepreneurs with a
                    shared passion for online gaming. Rollbit is committed to
                    creating unique and fun experiences for it's users. A
                    diverse selection of games is available including slots,
                    table games, game shows and exclusive in-house games.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
         </div>
        </div>
      </div>
    </Layout>
  );
};

export default FaqPage;
